import { put, takeLatest, all, call } from 'redux-saga/effects';
import { setAction } from '../actions/themesPage';
import actionTypes from '../../../redux/actions/action-types';
import {
  getTeamThemesAllWithTeamid,
  getTeamThemesDeletedWithTeamid,
  getDivisionThemesAllWithDivisionid,
  postTeamChartmetaUsingTeamidAndChartid,
  getTeamThemesSearchWithTeamid,
  getDivisionThemesSearchWithDivisionid,
  getDivisionThemesDeletedWithDivisionid,
} from '../../../api/cloudApiGenerated';

export function* getTeamThemes(params) {
  let { team, division, query, deleted, paths, checkPermission, page, pageSize } = params.data;
  var getThemesAjax = function () {
    if (deleted) {
      if (division && division.id !== null) return getDivisionThemesDeletedWithDivisionid(division.id, page, pageSize);
      else return getTeamThemesDeletedWithTeamid(team.id, page, pageSize);
    } else {
      let searched = query && query.length > 0;
      if (division && division.id !== null) {
        return searched
          ? getDivisionThemesSearchWithDivisionid(division.id, query, page, pageSize)
          : getDivisionThemesAllWithDivisionid(division.id, page, pageSize);
      } else {
        return searched
          ? getTeamThemesSearchWithTeamid(team.id, query, page, pageSize)
          : getTeamThemesAllWithTeamid(team.id, page, pageSize);
      }
    }
  };

  try {
    let data = yield call(getThemesAjax);

    data.data = data.data.map((theme) => {
      const editLink = paths.editTheme.replace(':themeid', theme.id);
      const editLayout = paths.editLayout.replace(':storyid', theme.id);
      const editTable = paths.editTable.replace(':tableid', theme.id);

      let link = editLink;
      if (theme.chart_type === 4) link = editLayout;
      else if (theme.chart_type === 5) link = editTable;
      theme.href = link;

      return theme;
    });

    yield put(
      setAction({
        page: page,
        pageSize: pageSize,
        pageCount: data.pageCount,
        themes: data.data,
        dataReturned: true,
      })
    );
  } catch (error) {
    yield put(
      setAction({
        error: 'loading themes: ' + error.message || error.toString(),
      })
    );
  }
}

/** Watch functions */
export function* watchGetTeamThemes() {
  yield takeLatest(actionTypes.themesPage.getTeamThemes, getTeamThemes);
}

// notice how we now only export the rootSaga
// single entry point to start all Sagas at once
export default function* rootSaga() {
  yield all([watchGetTeamThemes()]);
}
